// Generated by `bazel run i18n`. Do not edit by hand.
import model_08449dfe from "./en/model.json";

export default Object.assign(
  {},
  model_08449dfe,
);
